import Vue from "vue";
import dotenv from "dotenv";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import vuescroll from "vuescroll";
import CKEditor from "@ckeditor/ckeditor5-vue";

// global component
import Snackbar from "@/components/Snackbar";

dotenv.config();

Vue.config.productionTip = false;
Vue.use(CKEditor);
Vue.use(vuescroll, {
  ops: {
    scrollPanel: {
      scrollingX: false,
      verticalNativeBarPos: "right"
    }
  },
  name: "vue-scroll"
});
Vue.component("Snackbar", Snackbar);
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
